import { List } from 'antd';
import styled from 'styled-components';

export const StyledList = styled(List)<{ $mapHeight: string; $overflowY: string }>`
  overflow-y: ${({ $overflowY }) => $overflowY};
  max-height: ${({ $mapHeight }) => $mapHeight};
`;

export const StyledListItem = styled(List.Item)<{ $backgroundColor: string }>`
  background-color: ${({ $backgroundColor }) => $backgroundColor};
  border-bottom: 1px solid ${({ theme }) => theme.borderColor} !important;
  color: ${({ theme }) => theme.headerColor};
  cursor: pointer;
`;

export const ListItemLabel = styled.span`
  font-size: 0.9rem;
  min-width: 4rem;
  margin-right: 0.5rem;
  text-align: right;
`;

export const ListItemValue = styled.span`
  font-size: 0.9rem;
  margin: 0;
`;

export const RowContainer = styled.div`
  display: flex;
  margin-left: 1rem;
  margin-bottom: 0.5rem;
`;
